import React from "react";
import {
  
  FaUsers,
 
} from "react-icons/fa";
import { MdElectricBike } from "react-icons/md";

const Profile = () => {
  return (
    <div className="bg-white text-black font-OpenSans p-6 md:p-10 space-y-10">
      {/* Our Brands */}
      <div>
        <h1 className="text-center text-2xl font-bold">Company Profile</h1>
        <p className="font-bold">
          Garuda Mart India Pvt. Ltd. is a fast-emerging leader in India’s home
          appliances sector. Founded in 2017,the company is known for its
          commitment to innovation, quality, and customer-centricity.
          Headquartered at the KIADB Industrial Area in Karnataka, Garuda Mart
          is setting new benchmarks in manufacturing and retailing advanced,
          eco-friendly products.
        </p>
      </div>
      <div>
        <h1 className="text-2xl md:text-3xl text-center font-bold ">
          THE PHILOSOPHIES OF THE COMPANY
        </h1>
        <p className="mt-8">
          <span className="font-bold">GARUDA MART INDIA PVT LTD. </span>Plans to
          sustain its competitive advantages of being customer-centric and
          providing an extended portfolio of products through the following
          strategies:{" "}
        </p>
        <ul className="list-disc pl-5 text-sm leading-6 mt-2 ">
          <li>
            Strengthening market position by increasing responsiveness to
            customer requirements.
          </li>
         
          <li>
            The Company delivers the high-quality products that its clients
            appreciate. As a company with a proven record of solid operations,
            the unit knows how to provide superior, marketing activities and
            their philosophy does not allow compromising these standards.
          </li>
         
          <li>
            The Company intend to include KAIZEN philosophy of Continuous
            Improvement of working practices by everybody, every day, every
            where.{" "}
          </li>
          
          <li>
            Providing cost-effective solutions through augmented productivity,
            resulting from innovation and economies of scale.
          </li>
          <li>
            Manufacturing capacity expansions which include internal expansion
            and increasing the number of manufacturing units.
          </li>
         
          <li>
            To be the best and largest Manufacturing unit for Home Appliances.
          </li>
          
          <li>To train, generate and retain talented team.</li>
          
        </ul>
      </div>
      <div>
        <h1 className="text-2xl md:text-3xl text-center font-bold ">
          VISION & MISSION
        </h1>
        <p>
          GARUDA MART INDIA PVT LTD, and will be the driving force for all
          future initiatives. The Company aims to build brand loyalty on its
          journey from excellence to exemplary.
        </p>
        <h1 className="text-2xl mt-3  underline ">Vision</h1>
        <ul className="list-disc pl-5 text-sm leading-6 mt-2">
          <li>
            {" "}
            To be the global leading producers of world class specialty Home
            Appliances using state of the art technology, innovative
            manufacturing set up, cutting edge digital systems and outstanding
            work-force.
          </li>
          <li>
            To create a healthy and a prosperous future for the generations to
            come.
          </li>
          <li>
            To share their knowledge with people around the globe, for a better
            tomorrow.
          </li>
          <li>To become consumer’s most trusted brand.</li>
        </ul>
        <h1 className="text-2xl mt-3 underline ">Mission</h1>
        <ul className="list-disc pl-5 text-sm leading-6 mt-2">
          <li>
            To provide 100% customer satisfaction and perfectly fulfill
            customers’ needs.
          </li>
          <li>
            To guarantee the best quality products to their customers by
            focusing on operational excellence and product innovation.
          </li>
          <li>
            To establish mutual respect and long-term relations with all their
            stake holders.
          </li>
          <li>
            Their commitment to quality, consistency and improvement on a
            continuous basis.
          </li>
          <li>
            {" "}
            Deliver satisfaction and quality assurance to its consumers using
            state of the art technology.{" "}
          </li>
          <li>
            Offer a work environment that inspires trust and loyalty in people.{" "}
          </li>
          <li>
            Engage in continuous efforts to explore new horizons in its business
          </li>
        </ul>
      </div>
      <div>
        <h2 className="text-2xl md:text-3xl font-bold flex items-center gap-2 mb-4">
          <MdElectricBike /> Official Distribution Partnership
        </h2>
        <div className="bg-gray-100 p-5 rounded-2xl shadow hover:shadow-lg transition">
          <p className="text-sm">
            Garuda Mart India is the official South India distributor for{" "}
            <strong>Joy E-bike</strong> (Wardwizard Innovations), supporting the
            shift to electric mobility.
          </p>
        </div>
      </div>

      {/* Market Footprint */}
      <div>
        <h2 className="text-2xl md:text-3xl font-bold flex items-center gap-2 mb-4">
          <FaUsers /> Market Footprint
        </h2>
        <div className="bg-gray-100 p-5 rounded-2xl shadow hover:shadow-lg transition">
          <p className="text-sm">
            👥 <strong>Customer Base:</strong> 5,00,000+ users
          </p>
          <p className="text-sm">
            🧩 <strong>Dealer Network:</strong> 1200+ dealers (South India)
          </p>
          
        </div>
      </div>

      {/* Product Innovation */}
      {/* <div>
        <h2 className="text-2xl md:text-3xl font-bold flex items-center gap-2 mb-4">
          <FaLightbulb /> Product Innovation
        </h2>
        <div className="bg-gray-100 p-5 rounded-2xl shadow hover:shadow-lg transition">
          <p className="text-sm">
            We hold patents for our smart dishwashers including:
          </p>
          <ul className="list-disc pl-5 text-sm leading-6 mt-2">
            <li>UV Sterilization</li>
            <li>360° Five Jet Spray</li>
            <li>AI Wash Mechanism</li>
            <li>Antimicrobial Filters</li>
            <li>LED Touch + Inverter Motor</li>
          </ul>
        </div>
      </div> */}

      {/* Strategic Distribution */}
    </div>
  );
};

export default Profile;
